import React, { useEffect, useState } from "react";
import {
  DashboardLayout,
  DeletePopupModal,
  FormParser,
  PopupModal,
} from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import DataTable from "react-data-table-component";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import "./master_categories.css";
import { BsFillCloudUploadFill } from "react-icons/bs";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { BiSearch } from "react-icons/bi";
import { AiTwotoneSetting } from "react-icons/ai";
import { CiCirclePlus } from "react-icons/ci";
import { HiOutlineEye } from "react-icons/hi";
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdDelete,
  MdOutlineFileUpload,
} from "react-icons/md";
import { FiSave } from "react-icons/fi";
import { CMSNavbarComponent } from "../Components/navbar/CMSnavcomponent";
import masters from "../Components/masters.json";
import { FileManager } from "../Components/FileManager";
const BannerOld = () => {
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [RowId, SetRowId] = useState();
  let masterModal = masters.Banners;
  let navigate = useNavigate();
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [popupType, setpopupType] = useState("");
  const [show, setShow] = useState(false);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [promotionalCategoryOptions, setPromotionalCategoryOptions] = useState([]);
  const [modalTitle, setModalTitle] = useState("Add New Item");
  const linkTypeOptions = [
    { value: "subcategory", label: "Sub Category" },
    { value: "promotional_category", label: "Promotional Category" },
  ];
  const [banner, setBanner] = useState([
    { value: "full_width", label: "Full Width" },
    { value: "slider", label: "Slider" },
    { value: "middle_banners", label: "Middle Banners" },
    { value: "featured_this_week", label: "Featured This Week" },
    // { value: "vertical_banner", label: "Vertical Banner" },
    // { value: "onebytwo_banners", label: "One by Two Banner" },
  ]);

  const handleClose = () => {
    setShow(false);
    setFormData({
      link_type: "",
      subcategory: "",
      promotional_category: "",
      image: "",
      banner_type: "",
      name: "",
    });
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        let allCategories = [];
        let nextPage = "catlog/sub-categories/?is_suspended=false";

        while (nextPage) {
          const response = await axiosConfig.get(nextPage);
          const subcategories = response.data.results.map((subcategory) => ({
            value: subcategory.id,
            label: subcategory.name,
          }));
          allCategories = allCategories.concat(subcategories);
          nextPage = response.data.next;
        }

        setSubcategoryOptions(allCategories);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        setSubcategoryOptions([]);
      }
    };

    const fetchPromotionalCategories = async () => {
      try {
        let allPromotionalCategories = [];
        let nextPagePromo = "cms/promotional_category/?is_suspended=false";

        while (nextPagePromo) {
          const response = await axiosConfig.get(nextPagePromo);
          const promoCategories = response.data.results.map((category) => ({
            value: category.id,
            label: category.title,
          }));
          allPromotionalCategories = allPromotionalCategories.concat(promoCategories);
          nextPagePromo = response.data.next;
        }

        setPromotionalCategoryOptions(allPromotionalCategories);
      } catch (error) {
        console.error("Error fetching promotional categories:", error);
        setPromotionalCategoryOptions([]);
      }
    };

    fetchCategories();
    fetchPromotionalCategories();
  }, []);

  const tableCustomStyles = {
    table: {
      style: {
        backgroundColor: "#fff",
        borderRadius: "18px",
        overflow: "hidden",
        border: "1px solid #e8e8e8",
        margin: "10px 10px"
      },
    },

    headRow: {
      style: {
        minHeight: "68px",
        borderBottom: "1px solid #ececec",
        backgroundColor: "#fff",
      },
    },

    headCells: {
      style: {
        fontSize: "11px",
        fontWeight: "500",
        color: "#6b7280",
        textTransform: "uppercase",
        letterSpacing: "1px",
        fontFamily: "Inter, sans-serif",
        paddingLeft: "18px",
        paddingRight: "18px",
      },
    },

    rows: {
      style: {
        minHeight: "78px",
        borderBottom: "1px solid #f1f1f1",
        fontSize: "13px",
        fontWeight: 500,
        fontFamily: "Inter, sans-serif",
      },
    },

    cells: {
      style: {
        paddingLeft: "18px",
        paddingRight: "18px",
        whiteSpace: "normal",
        lineHeight: "15px",
      },
    },

    pagination: {
      style: {
        borderTop: "1px solid #ececec",
        minHeight: "60px",
      },
    },
  };
  const handleShow = () => {
    setShow(true);
    setSelectedImage("");
    setFormData({
      link_type: "",
      subcategory: "",
      promotional_category: "",
      image: "",
      name: "",
      banner_type: "",
    });
    setcatid(null);
    setModalTitle("Add New Item");
  };

  const HandleDropdownChange = (selectedOption, name) => {
    setFormData({
      ...formData,
      [name]: {
        value: selectedOption.value,
        label: selectedOption.label,
      },
    });
  };
  const [catid, setcatid] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [search, SetSearch] = useState({
    search: "",
  });
  const [Datafilter, SetDatafilter] = useState([]);
  const [Data, SetData] = useState([]);
  const [name, setName] = useState("");
  const GetData = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get(
        `catlog/banners/?page=${currentPage}&page_size=${RowPerPage}&is_suspended=false`
      );
      SetData(responce.data.results);
      setLoading(false);
      setTotalRows(responce.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
    axiosConfig
      .get(`catlog/banners/`)
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSort = (column, direction) => {
    console.log(column.selector, direction);
    axiosConfig
      .get(
        `catlog/banners/?ordering=${direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const [formData, setFormData] = useState({
    link_type: "",
    subcategory: "",
    promotional_category: "",
    image: "",
    banner_type: "",
    name: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleImageChange = (files) => {
    console.log(files);
    const file = files[0].image;
    const file_key = files[0].id;
    setSelectedImage(file);
    setFormData({ ...formData, ["image"]: file_key });
  };
  const Handlefilemanager = () => {
    setModalShow(true);
  };

  const catedit = (id) => {
    axiosConfig
      .get(`catlog/banners/${id}/`)
      .then((res) => {
        console.log(res);
        setFormData({
          image: res.data.image?.id,
          banner_type: res.data.banner_type,
          name: res.data.name,
          link_type: res.data.link_type,
          subcategory: res.data.subcategory ? {
            value: res.data.subcategory.id,
            label: res.data.subcategory.name,
          } : "",
          promotional_category: res.data.promotional_category ? {
            value: res.data.promotional_category.id,
            label: res.data.promotional_category.title,
          } : "",
        });
        setSelectedImage(res.data.image?.image);
        setcatid(id);
        setShow(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage]);

  console.log(formData);
  const formSubmit = (id) => {
    let payload = {
      name: formData.name,
      banner_type: formData.banner_type?.value || formData.banner_type,
      link_type: formData.link_type?.value || formData.link_type,
    };

    if (payload.link_type === "subcategory") {
      payload.subcategory = formData.subcategory?.value || null;
      payload.promotional_category = null;
    } else if (payload.link_type === "promotional_category") {
      payload.promotional_category = formData.promotional_category?.value || null;
      payload.subcategory = null;
    }

    if (selectedImage && formData.image) {
      payload.image = formData.image;
    }

    axiosConfig.defaults.headers["Content-Type"] = "application/json";
    if (id) {
      axiosConfig
        .patch(`catlog/banners/${id}/`, payload)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetData();
          handleClose();
        })
        .catch((error) => {
          console.log(error);
          setpopupType("error");
        });
    } else {
      axiosConfig
        .post("catlog/banners/", payload)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetData();
          handleClose();
        })
        .catch((error) => {
          console.log(error);
          setpopupType("error");
        });
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
      reorder: true,
      // style : {display : "flex",justifyContent : "center"},
    },
    {
      name: "Name",
      selector: "name",
      cell: (row) => row.name,
      sortable: true,
      reorder: true,
      // width : "200px",
      style: { justifyContent: "left" },
    },

    {
      name: "image",
      selector: (row) => (
        <>
          <img
            className="image"
            src={row.image && row.image.image}
            alt={row.image}
          />
        </>
      ),
      sortable: true,
      reorder: true,
       width : "200px",
    },
    {
      name: "Link Type",
      selector: "link_type",
      cell: (row) => row.link_type,
      sortable: true,
      reorder: true,
       width : "150px",
    },
    {
      name: "Linked To",
      selector: "linked_to",
      cell: (row) => row.link_type === "subcategory" ? row.subcategory_name : (row.link_type === "promotional_category" ? row.promotional_category_name : ""),
      sortable: false,
      reorder: true,
    },
    {
      name: "ACTIONS",
      reorder: true,
      width: "240px",
      selector: (row) => {
        const HandleEdit = async () => {
          console.log(row.id, "iddddd");
          catedit(row.id);
          setModalTitle("Edit Item");
        };
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (id) => {
          await axiosConfig
            .delete(`catlog/banners/${id}/`)
            .then(() => {
              SetAlertDeletePopupType("error");
              setDeletepopupType("success");
              GetData();
            })
            .catch((error) => {
              setDeletepopupType("error");
              SetAlertDeletePopupType("error");
              console.log(error);
            });
        };
        return (
          <>
            <div className="row">
              <div className="table-actions">
                <button className="action-btn edit-btn" onClick={HandleEdit}>
                  <MdOutlineEdit /> Edit
                </button>

                <button className="action-btn delete-btn" onClick={DeleteAlert}>
                  <MdDeleteOutline /> Delete
                </button>
              </div>
            </div>

            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  return (
    <>
      <div className="child-sidenav">
        <CMSNavbarComponent />
        <div className="childnav-content">
          <div className="text-block-end">
            <div className="text-block-border">
              <h5 className="dashboard-subtitle">Banner Slider</h5>
              <div className="d-flex gap-4">
                <AiTwotoneSetting color="#5C5C5C" />
                <CiCirclePlus />
                <HiOutlineEye />
                <MdOutlineEdit />
                <FiSave />
                <MdKeyboardArrowUp />
                <MdKeyboardArrowDown />
                <MdDelete />
              </div>
            </div>
            <div className="p-2">
              <button className="btn btn-primary" onClick={handleShow}>
                + Add New Banner Slider Item
              </button>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={Data}
                  pagination
                  paginationTotalRows={totalRows}
                  paginationPerPage={RowPerPage}
                  draggableColumns
                  paginationDefaultPage={currentPage}
                  onChangePage={(page) => setCurrentPage(page)}
                  paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  onChangeRowsPerPage={(RowsPerPageChange) =>
                    setRowPerPage(RowsPerPageChange)
                  }
                  onSort={handleSort}
                  paginationServer
                  fixedHeader
                  subHeader
                  customStyles={tableCustomStyles}
                  progressPending={loading}
                  progressComponent={
                    <div className="loader-container">
                      <img
                        src={require("../Components/FormParser/images/loader2.gif")}
                        alt="Loading..."
                      />
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <FormParser masterModal={masterModal}/> */}
          <form>
            <div className="row align-items-center">
              <div className="col-6 banner-image">
                <div className="image-field">
                  <label
                    className="image-container"
                    htmlFor="imageInput"
                    onClick={Handlefilemanager}
                  >
                    {formData.image_key || selectedImage ? (
                      <img
                        className="image"
                        src={selectedImage}
                        alt={formData.image_key}
                      />
                    ) : (
                      <label htmlFor="imageInput" className="image-icon">
                        <BsFillCloudUploadFill className="upload-icon" />
                        <p className="textfile">Choose a file</p>
                      </label>
                    )}
                  </label>
                </div>
              </div>
              <div className="col-6 banner-form">
                <div className="form-fields">
                  <label htmlFor="link_type">Link Type:</label>
                  <Select
                    options={linkTypeOptions}
                    value={linkTypeOptions.find(
                      (res) => res.value === (formData.link_type?.value || formData.link_type)
                    )}
                    onChange={(selectedOption) =>
                      HandleDropdownChange(selectedOption, "link_type")
                    }
                    placeholder="Select Link Type"
                    required
                  />
                </div>
              </div>
              {(formData.link_type?.value || formData.link_type) === "subcategory" && (
                <div className="col-6 banner-form">
                  <div className="form-fields">
                    <label htmlFor="subcategory">Subcategory:</label>
                    <Select
                      options={subcategoryOptions}
                      value={formData.subcategory}
                      onChange={(selectedOption) =>
                        HandleDropdownChange(selectedOption, "subcategory")
                      }
                      placeholder="Select Subcategory"
                      required
                    />
                  </div>
                </div>
              )}
              {(formData.link_type?.value || formData.link_type) === "promotional_category" && (
                <div className="col-6 banner-form">
                  <div className="form-fields">
                    <label htmlFor="promotional_category">Promotional Category:</label>
                    <Select
                      options={promotionalCategoryOptions}
                      value={formData.promotional_category}
                      onChange={(selectedOption) =>
                        HandleDropdownChange(selectedOption, "promotional_category")
                      }
                      placeholder="Select Promotional Category"
                      required
                    />
                  </div>
                </div>
              )}
              <div className="col-6 banner-form">
                <div className="form-fields">
                  <label htmlFor="subcategory">Banner Type:</label>
                  <Select
                    options={banner}
                    value={banner.find(
                      (res) => res.value === formData.banner_type
                    )}
                    onChange={(selectedOption) =>
                      HandleDropdownChange(selectedOption, "banner_type")
                    }
                    placeholder="Select Banner Type"
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Name:</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleFormChange}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          {catid ? (
            <>
              <button
                type="button"
                className="btn custom-submit-button"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn custom-submit-button"
                onClick={() => formSubmit(catid)}
              >
                Save Changes
              </button>
            </>
          ) : (
            <button
              type="button"
              className="btn custom-submit-button"
              onClick={() => formSubmit(null)}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      {popupType != "" && (
        <PopupModal
          popupType={popupType}
          Navigation="/dashboard/cms/old-banner"
          setpopupType={setpopupType}
        />
      )}
      {deletePopupType != "" && (
        <DeletePopupModal
          setDeletepopupType={setDeletepopupType}
          deletePopupType={deletePopupType}
        />
      )}
      {modalShow && (
        <FileManager
          modalShow={modalShow}
          setModalShow={setModalShow}
          handleFile={handleImageChange}
          ismultiple={false}
          value="image_key"
        />
      )}
    </>
  );
};
export { BannerOld };
